// import { faker } from "@faker-js/faker";
import storage from "../utils/storage";
import { getUser, loginWithEmail, registerWithEmail } from "../apis";

export async function loginFn(data) {
  const response = await loginWithEmail(data);
  storage.setToken(response.data.token);
  return response;
}

export async function registerFn(data) {
  const response = await registerWithEmail(data);
  storage.setToken(response.data.token);
  return response;
}

export async function logoutFn() {
  storage.clearToken();
  window.location.assign(window.location.origin);
}

export async function verifyUser() {
  if (storage.getToken()) {
    try {
      const response = await getUser();
      return response.status === 200 ? response.data : null;
    } catch (error) {
      storage.clearToken();
    }
  }
  return null;
}

// export async function demoLogin() {
//   const response = await registerWithEmail({
//     email: faker.internet.email(),
//     password: faker.internet.password(),
//     first_name: "Guest",
//     last_name: "User",
//     is_guest: true,
//   });
//   storage.setToken(response.data.token);
//   return response;
// }
